import type { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/molecules/dialog";
import { Kbd, KbdGroup } from "@/components/atoms/kbd";
import {
  RTE_SHORTCUTS_DIALOG_TITLE,
  RTE_SHORTCUTS_DIALOG_DESCRIPTION,
} from "@/constants/uiCopy/richTextEditor";
import { getModKeyLabel } from "@/hooks/modKeyLabel";
import {
  CONSOLE_DIALOG_BODY_CLASS,
  CONSOLE_DIALOG_TITLE_CLASS,
} from "@/lib/ui/consoleDialogTypography";
import { cn } from "@/lib/utils";
import { getRteShortcutRows } from "../toolbar/shared/richTextEditorToolbarShortcuts";

export interface KeyboardShortcutsModalProps {
  children: ReactNode;
}

export const KeyboardShortcutsModal = ({
  children,
}: KeyboardShortcutsModalProps) => {
  const modKeyLabel = getModKeyLabel();
  const shortcutRows = getRteShortcutRows(modKeyLabel);

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent surface="console">
        <DialogHeader>
          <DialogTitle className={CONSOLE_DIALOG_TITLE_CLASS}>
            {RTE_SHORTCUTS_DIALOG_TITLE}
          </DialogTitle>
          <DialogDescription
            id="rte-shortcuts-desc"
            className={CONSOLE_DIALOG_BODY_CLASS}
          >
            {RTE_SHORTCUTS_DIALOG_DESCRIPTION}
          </DialogDescription>
        </DialogHeader>
        <ul
          className={cn(CONSOLE_DIALOG_BODY_CLASS, "flex flex-col gap-2")}
          aria-labelledby="rte-shortcuts-desc"
        >
          {shortcutRows.map((row) => (
            <li
              key={row.name}
              className="flex items-center justify-between gap-4"
            >
              <span>{row.name}</span>
              <KbdGroup>
                {row.keys.map((k) => (
                  <Kbd key={`${row.name}-${k}`}>{k}</Kbd>
                ))}
              </KbdGroup>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
